module.exports = __webpack_public_path__ + "img/stretch--genre4_tab-active.3a3ed4c1.png";